import React, { useState, useEffect } from "react";

const VideoLinkForm = ({ data, onSubmit, onCancel }) => {
  const [video, setVideo] = useState({
    title: "",
    url: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (data) {
      setVideo(data);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVideo((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!video.title.trim() || !video.url.trim()) {
      setError("Both Title and URL are required.");
      return;
    }
    setError("");
    onSubmit(video);
  };

  return (
    <div>
      <h3>{data?.id ? "Edit Video Link" : "Add Video Link"}</h3>
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="form-group">
          <label>Video Title</label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={video.title}
            onChange={handleChange}
            placeholder="Enter video title"
          />
        </div>
        <div className="form-group">
          <label>YouTube URL</label>
          <input
            type="url"
            className="form-control"
            name="url"
            value={video.url}
            onChange={handleChange}
            placeholder="Enter YouTube video link"
          />
        </div>
        {error && <small className="text-danger">{error}</small>}

        <div className="mt-3">
          <button type="submit" className="btn btn-success mr-2">
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default VideoLinkForm;
